import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { HybridConfig, HYBRID_CONFIG } from './entities';
import { HybridDirective } from './hybrid.directive';
import { HybridIframeComponent } from './components/hybrid-iframe/hybrid-iframe.component';
import { HybridIframeContainerDirective } from './directives/hybrid-iframe-container.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [HybridDirective, HybridIframeComponent, HybridIframeContainerDirective],
    exports: [HybridDirective, HybridIframeComponent, HybridIframeContainerDirective]
})
export class HybridModule {
    static config(config: HybridConfig): ModuleWithProviders<HybridModule> {
        return {
            ngModule: HybridModule,
            providers: [{ provide: HYBRID_CONFIG, useValue: config }]
        };
    }
}
